// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__11I-s","brand":"Nav_brand__2gWXM"};